<div class="main-container">
    <div #mapViewNode></div>
</div>